const styles = theme => ({
  root: {
    '& > *': {
      margin: theme.spacing(1),
    },
  },
});

export default styles;